import { render } from "./ModuleEmployeesSkillsAudits.vue?vue&type=template&id=59b635ca&scoped=true"
import script from "./ModuleEmployeesSkillsAudits.vue?vue&type=script&lang=js"
export * from "./ModuleEmployeesSkillsAudits.vue?vue&type=script&lang=js"

import "./ModuleEmployeesSkillsAudits.vue?vue&type=style&index=0&id=59b635ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b635ca"]])

export default __exports__